import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { UserChatState } from 'store/user_chat/types';
import { initialState as USER_CHAT_INITIAL_STATE } from 'store/user_chat/initialState';

export const getUserChatState = (state: RootState): UserChatState =>
  state?.userChat ?? USER_CHAT_INITIAL_STATE;

export const getUserChatAnswer = createSelector(
  [getUserChatState],
  (state: UserChatState): string | null => state?.data?.answer ?? null
);
